import { useCallback, useContext } from 'react';
import { FiscalPeriodsContext } from './index';
import useGetFiscalPeriodInYear from './useGetFiscalPeriodInYear';

const useGetFiscalPeriodLabel = () => {
  const { fiscalPeriods } = useContext(FiscalPeriodsContext);
  const getFiscalPeriodInYear = useGetFiscalPeriodInYear();

  const getFiscalPeriodLabel = useCallback(
    (periodStart: string) => {
      const fiscalPeriod = fiscalPeriods.find(
        (p) => p.startDate === periodStart,
      );

      if (!fiscalPeriod) {
        return '';
      }

      const periodYear = fiscalPeriod.currentYear.toString().slice(2);

      return `FY${periodYear} - ${getFiscalPeriodInYear(fiscalPeriod.startDate)}`;
    },
    [fiscalPeriods, getFiscalPeriodInYear],
  );

  return getFiscalPeriodLabel;
};

export default useGetFiscalPeriodLabel;
